export default __webpack_public_path__ + "static/media/Encrypted.34e47dd1.png";